<app-alert></app-alert>
<section class="panel panel-default">
    <div class="card-header">
      <title>SH-6 Register of Employee Stock Options</title>
      <span class="cat__core__title">
        <strong id="pageTitle">SH-6 Register of Employee Stock Options</strong>
      </span>
      
      <span style="float: right">
        <!-- <a routerLink="/mastersh6"> -->
            <button (click)="back()"  class="btn btn-sm btn-default pull-right btn-back" type="button">
                <i class=" fa fa-chevron-circle-left"></i>
                Back
            </button>
        <!-- </a> -->
    </span>
    <!-- <span style="float:right">
      <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button" *ngIf="restrictTabflag">
        <span>
          <i class="fa fa-save"></i>Generate Output</span>
      </button>
</span> -->
      <meta charset="utf-8">
    </div>

      <form [formGroup]='shForm' (document:click)="a.close();b.close();c.close()">
          <div class="modal-body">
                  <div class="row">
                      <div class="col-md-4 col-sm-6 col-xs-12">
                          <label class="form-control-label">Date of special resolution</label>
                          <span _ngcontent-c2="" style="color: red;">*</span>
                          <div class="form-group">
                              <div class="input-group" (click)="$event.stopPropagation()">
                                <input class="form-control"  [formControl]="shForm.controls['dateOfSpecialResolution']" [(ngModel)]="dateOfSpecialResolutionModel"
                                    style="padding:6px;z-index: 0;"  placeholder="dd-mm-yyyy"
                                    name="dateOfSpecialResolution" ngbDatepicker #a="ngbDatepicker" (click)="a.toggle()">
                                <button class="input-group-addon" (click)="a.toggle()"
                                    type="button">
                                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                </button>
                              </div>
                              <div *ngIf="shForm.controls['dateOfSpecialResolution'].hasError('required') && shForm.controls['dateOfSpecialResolution'].touched"
                              class="form-control-error-custom">
                              Date of special resolution is required
                              </div> 
                              <div *ngIf="(shForm.controls['dateOfSpecialResolution'].hasError('pattern') || shForm.controls['dateOfSpecialResolution'].hasError('maxlength')) && shForm.controls['dateOfSpecialResolution'].touched"
                              class="form-control-error-custom">
                              Date of special resolution is invalid
                          </div>
                          </div>
                      </div>
                      <div class="col-md-4 col-sm-6 col-xs-12">
                          <label class="form-control-label">Name of the grantee</label>
                          <span _ngcontent-c2="" style="color: red;">*</span>
                          <div class="form-group">
                              <input type="text" [formControl]="shForm.controls['nameOfTheGrantee']" class="form-control" (keydown)="noBlankSpaceAtStart($event)">
                              <div *ngIf="shForm.controls['nameOfTheGrantee'].hasError('required') && shForm.controls['nameOfTheGrantee'].touched" class="form-control-error-custom">
                                Name of the grantee is required
                              </div>
                              <div *ngIf="(shForm.controls['nameOfTheGrantee'].hasError('pattern') || shForm.controls['nameOfTheGrantee'].hasError('maxlength')) && shForm.controls['nameOfTheGrantee'].touched"
                              class="form-control-error-custom">
                              Name of the grantee is invalid
                          </div>
                          </div>
                      </div>
                      <div class="col-md-4 col-sm-6 col-xs-12">
                          <label class="form-control-label">Number of options granted</label>
                          <span _ngcontent-c2="" style="color: red;">*</span>
                          <div class="form-group">
                              <input type="text" [formControl]="shForm.controls['numberOfOptionsGranted']" class="form-control" (keydown)="noBlankSpaceAtStart($event)">
                              <div *ngIf="shForm.controls['numberOfOptionsGranted'].hasError('required') && shForm.controls['numberOfOptionsGranted'].touched" class="form-control-error-custom">
                                Number of options granted is required
                              </div>
                              <div *ngIf="(shForm.controls['numberOfOptionsGranted'].hasError('pattern') || shForm.controls['numberOfOptionsGranted'].hasError('maxlength')) && shForm.controls['numberOfOptionsGranted'].touched"
                              class="form-control-error-custom">
                              Number of options granted is invalid
                          </div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-4 col-sm-6 col-xs-12">
                          <label class="form-control-label">Date on which options vested</label>
                          <div class="form-group">
                              <div class="input-group" (click)="$event.stopPropagation()">
                                <input class="form-control"  [formControl]="shForm.controls['dateOnWhichOptionsVested']" [(ngModel)]="dateOnWhichOptionsVestedModel" 
                                    style="padding:6px;z-index: 0;"  placeholder="dd-mm-yyyy"
                                    name="dateOnWhichOptionsVested" ngbDatepicker #b="ngbDatepicker" (click)="b.toggle()">
                                <button class="input-group-addon" (click)="b.toggle()"
                                    type="button">
                                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                </button>
                              </div>
                              <div *ngIf="(shForm.controls['dateOnWhichOptionsVested'].hasError('pattern') || shForm.controls['dateOnWhichOptionsVested'].hasError('maxlength')) && shForm.controls['dateOnWhichOptionsVested'].touched"
                              class="form-control-error-custom">
                              Date on which options vested is invalid
                          </div>
                          </div>

                      </div>
                      <div class="col-md-4 col-sm-6 col-xs-12">
                          <label class="form-control-label">Exercise period-(Months)</label>
                          <span _ngcontent-c2="" style="color: red;">*</span>
                          <div class="form-group">
                              <input type="text" [formControl]="shForm.controls['excercisePeriod']" class="form-control" (keydown)="noBlankSpaceAtStart($event)">
                              <div *ngIf="shForm.controls['excercisePeriod'].hasError('required') && shForm.controls['excercisePeriod'].touched" class="form-control-error-custom">
                                Exercise period-(Months) is required
                              </div>
                            <div *ngIf="(shForm.controls['excercisePeriod'].hasError('pattern') || shForm.controls['excercisePeriod'].hasError('maxlength')) && shForm.controls['excercisePeriod'].touched"
                              class="form-control-error-custom">
                              Exercise period-(Months) is invalid
                          </div>
                          </div>
                      </div>
                      <div class="col-md-4 col-sm-6 col-xs-12">
                          <label class="form-control-label"> Date on which options exercised</label>
                          <div class="form-group">
                              <div class="input-group" (click)="$event.stopPropagation()">
                                <input class="form-control"  [formControl]="shForm.controls['dateOnWhichOptionsExcercised']" [(ngModel)]="dateOnWhichOptionsExcercisedModel"
                                    style="padding:6px;z-index: 0;"  placeholder="dd-mm-yyyy"
                                    name="dateOnWhichOptionsExcercised" ngbDatepicker #c="ngbDatepicker" (click)="c.toggle()">
                                <button class="input-group-addon" (click)="c.toggle()"
                                    type="button">
                                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                </button>
                              </div>
                              <div *ngIf="(shForm.controls['dateOnWhichOptionsExcercised'].hasError('pattern') || shForm.controls['dateOnWhichOptionsExcercised'].hasError('maxlength')) && shForm.controls['dateOnWhichOptionsExcercised'].touched"
                              class="form-control-error-custom">
                              Date on which options exercised is invalid
                          </div>
                           </div>
                      </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Options exercised</label>
                        <div class="form-group">
                            <input  type="text" [formControl]="shForm.controls['optionsexcercised']" class="form-control" (keydown)="noBlankSpaceAtStart($event)">
                           <div *ngIf="(shForm.controls['optionsexcercised'].hasError('pattern') || shForm.controls['optionsexcercised'].hasError('maxlength')) && shForm.controls['optionsexcercised'].touched"
                              class="form-control-error-custom">
                              Options exercised is invalid
                          </div>
                          </div>
                       
                    </div>
                    <div class="col-md-4 col-sm-6 col-xs-12">
                       <label class="form-control-label">Exercise price</label>
                       <div class="form-group">
                            <input type="text" [formControl]="shForm.controls['excercisePrice']" class="form-control" (keydown)="noBlankSpaceAtStart($event)">
                            <div *ngIf="(shForm.controls['excercisePrice'].hasError('pattern') || shForm.controls['excercisePrice'].hasError('maxlength')) && shForm.controls['excercisePrice'].touched"
                              class="form-control-error-custom">
                              Exercise price is invalid
                          </div>
                          </div>
                        
                    </div>
                    <div class="col-md-4 col-sm-6 col-xs-12">
                        <label class="form-control-label">Number of shares arising as result of exercise of option</label>
                        <div class="form-group">
                            <input type="text" [formControl]="shForm.controls['numberOfSharesArisingAsResultOfExcerciseOfOption']" class="form-control" maxlength="200" (keydown)="noBlankSpaceAtStart($event)">
                            <div *ngIf="(shForm.controls['numberOfSharesArisingAsResultOfExcerciseOfOption'].hasError('pattern') || shForm.controls['numberOfSharesArisingAsResultOfExcerciseOfOption'].hasError('maxlength')) && shForm.controls['numberOfSharesArisingAsResultOfExcerciseOfOption'].touched"
                            class="form-control-error-custom">
                            Number of shares arising as result of exercise of option is invalid
                        </div>
                          </div>
                        
                    </div>
                </div>
                <div class="row">
                  <div class="col-md-4 col-sm-6 col-xs-12">
                      <label class="form-control-label">Folio number of register of members having respective entry<span _ngcontent-c2="" style="color: red;">*</span></label>
                      
                          <div class="form-group">
                              <input type="text" [formControl]="shForm.controls['folioNumberOfRegisterOfMembersHavingRespectiveEntry']" class="form-control" (keydown)="noBlankSpaceAtStart($event)">
                              <div *ngIf="shForm.controls['folioNumberOfRegisterOfMembersHavingRespectiveEntry'].hasError('required') && shForm.controls['folioNumberOfRegisterOfMembersHavingRespectiveEntry'].touched" class="form-control-error-custom">
                                Folio number of register of members having respective entry is required
                              </div>
                              <div *ngIf="(shForm.controls['folioNumberOfRegisterOfMembersHavingRespectiveEntry'].hasError('pattern') || shForm.controls['folioNumberOfRegisterOfMembersHavingRespectiveEntry'].hasError('maxlength')) && shForm.controls['folioNumberOfRegisterOfMembersHavingRespectiveEntry'].touched"
                            class="form-control-error-custom">
                            Folio number of register of members having respective entry is invalid
                        </div>
                          </div>
                  </div>
                  <div class="col-md-4 col-sm-6 col-xs-12"><br>
                     <label class="form-control-label">Lock in period, if any (in months)</label>
                     <div class="form-group">
                          <input  type="text" [formControl]="shForm.controls['lockInPeriod']" class="form-control" (keydown)="noBlankSpaceAtStart($event)">
                          <div *ngIf="(shForm.controls['lockInPeriod'].hasError('pattern') || shForm.controls['lockInPeriod'].hasError('maxlength')) && shForm.controls['lockInPeriod'].touched"
                          class="form-control-error-custom">
                          Lock in period, if any (in months) is invalid
                      </div>
                        </div>
                      
                  </div>
                  <div class="col-md-4 col-sm-6 col-xs-12"><br>
                      <label class="form-control-label">Option lapsed, if any</label>
                      <div class="form-group">
                          <input type="text" [formControl]="shForm.controls['optionLapsed']" class="form-control" (keydown)="noBlankSpaceAtStart($event)">
                          <div *ngIf="(shForm.controls['optionLapsed'].hasError('pattern') || shForm.controls['optionLapsed'].hasError('maxlength')) && shForm.controls['optionLapsed'].touched"
                          class="form-control-error-custom">
                          Option lapsed, if any is invalid
                      </div>
                        </div>
                      
                  </div>
                </div>
               <div class="row">
                <div class="col-md-4 col-sm-6 col-xs-12">
                    <label class="form-control-label">Total number of options in force</label>
                    <div class="form-group">
                        <input  type="text" [formControl]="shForm.controls['totalNumberOfOptionsInForce']" class="form-control" (keydown)="noBlankSpaceAtStart($event)">
                        <div *ngIf="(shForm.controls['totalNumberOfOptionsInForce'].hasError('pattern') || shForm.controls['totalNumberOfOptionsInForce'].hasError('maxlength')) && shForm.controls['totalNumberOfOptionsInForce'].touched"
                          class="form-control-error-custom">
                          Total number of options in force is invalid
                      </div>
                     </div>
                    
                </div>
                <div class="col-md-4 col-sm-6 col-xs-12">
                   <label class="form-control-label">Amount forfeited/ refunded if option is not exercised</label>
                   <div class="form-group">
                         <input  type="text" [formControl]="shForm.controls['amountForteitedIfOptionIsNotExcecuted']" class="form-control" (keydown)="noBlankSpaceAtStart($event)">
                       
                    <div *ngIf="(shForm.controls['amountForteitedIfOptionIsNotExcecuted'].hasError('pattern') || shForm.controls['amountForteitedIfOptionIsNotExcecuted'].hasError('maxlength')) && shForm.controls['amountForteitedIfOptionIsNotExcecuted'].touched"
                          class="form-control-error-custom">
                          Amount forfeited/ refunded if option is not exercised is invalid
                      </div>
                   </div>
                  
                </div>
              <div class="form-group col-md-4 col-sm-6 col-xs-12">
                  <label>Any variation of terms of the scheme and its effects</label>
                      <textarea [formControl]="shForm.controls['anyVariationOfTermsOfTheSchemeAndItsEffects']"  maxlength="200"
                          class="form-control" (keydown)="noBlankSpaceAtStart($event)"></textarea>
                      <div *ngIf="(shForm.controls['anyVariationOfTermsOfTheSchemeAndItsEffects'].hasError('pattern') || shForm.controls['anyVariationOfTermsOfTheSchemeAndItsEffects'].hasError('maxlength')) && shForm.controls['anyVariationOfTermsOfTheSchemeAndItsEffects'].touched"
                          class="form-control-error-custom">
                          Any variation of terms of the scheme and its effects is invalid
                      </div>
              </div>
               </div>
              </div>   
                  <div class="card-footer" align="right">
                    <div class="form-group" *ngIf="!restrictTabflag">
                      <button class="btn-sm btn btn-primary" (click)="showFormEntry()" type="button" [disabled]="!(shForm.valid) || disabledOnClick">
                            <span>
                                    <i class="fa fa-save"></i>&nbsp;Save </span>
                      </button>
                    </div>
                    <div class="form-group" *ngIf="restrictTabflag">
                      <button class="btn btn-sm btn-primary" (click)="updateSh6()" type="button" [disabled]="!(shForm.valid) || disabledOnClick">
                        <span>
                          <i class="fa fa-save"></i>&nbsp;Update </span>
                      </button>
                    </div>
                  </div>
        </form>    
  </section>    
